import {
    EmailRounded,
    ManageAccountsRounded,
    PaymentsRounded,
} from '@mui/icons-material';
import { Card, CardHeader, Stack } from '@mui/material';
import { MatchRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

const NavItem = ({ path, title, subheader, Icon }) => {
    const navigate = useNavigate();

    return (
        <MatchRoute to={path}>
            {active => {
                return (
                    <Card
                        onClick={() => navigate({ to: path })}
                        variant="filled"
                        sx={{
                            cursor: 'pointer',
                            backgroundColor: active ? 'primary.main' : 'unset',
                            color: active ? 'onPrimary.main' : 'default',
                            ...(active && {
                                '&:hover': {
                                    backgroundColor: 'primary.dark',
                                },
                            }),
                        }}
                    >
                        <CardHeader
                            title={title}
                            subheader={subheader}
                            {...(active
                                ? {
                                      subheaderTypographyProps: {
                                          color: 'onPrimary.main',
                                      },
                                  }
                                : {})}
                            avatar={
                                <Icon color={active ? 'default' : 'primary'} />
                            }
                        />
                    </Card>
                );
            }}
        </MatchRoute>
    );
};

const SettingsNavigation = () => {
    const { t } = useTranslation();

    const settings = [
        {
            path: '',
            title: t('Account'),
            subheader: t('settingsNavigation.account'),
            Icon: ManageAccountsRounded,
        },
        {
            path: 'emails',
            title: t('Emails'),
            subheader: t('settingsNavigation.emails'),
            Icon: EmailRounded,
        },
        {
            path: 'billing',
            title: t('Billing'),
            subheader: t('settingsNavigation.billing'),
            Icon: PaymentsRounded,
        },
    ];

    return (
        <Stack width={240}>
            {settings.map(({ path, title, subheader, Icon }) => (
                <NavItem
                    key={path}
                    path={'/settings/' + path}
                    title={title}
                    subheader={subheader}
                    Icon={Icon}
                />
            ))}
        </Stack>
    );
};

export default SettingsNavigation;
